// extracted by mini-css-extract-plugin
export default {"quantity-input":"DWZsY","quantityInput":"DWZsY","value":"yfxSd"};